export const ExpandableAnimations = {
  initial: { opacity: 0, y: -10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -10, transition: { duration: 0.3, ease: 'easeOut' } },
  hover: {
    scale: 1.05,
    transition: { duration: 0.3 },
  },
}

export const arrowRotate = {
  initial: { rotate: 180 },
  animate: { rotate: 0 },
  exit: { rotate: 180 },
  transition: { duration: 0.3 },
}
export const cardHoverAnimation = {
  initial: {},
  animate: { },
  exit: { },
  hover: {
    scale: 1.01,
    transition: { duration: 0.3 },
  },
}
export const BtnsHoverAnimation = {
  initial: {},
  animate: { },
  exit: { },
  hover: {
    scale: 1.05,
    transition: { duration: 0.3 },
  },
}

export const modalVariants = (modalState, isXsScreen) => ({
  hidden: isXsScreen ? { height: 0, opacity: 0 } : { opacity: 0 },
  visible: isXsScreen
    ? { height: modalState ? 'auto' : 0, opacity: modalState ? 1 : 0 }
    : { opacity: 1 },
  exit: isXsScreen ? { height: 0, opacity: 0 } : { opacity: 0 },
})
export const menuItemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.3,
    },
  }),
  exit: { opacity: 0, y: -20 },
}
export const getPopperAnimation = (popperStatus, height = 'auto') => ({
  initial: { height: 0, opacity: 0 },
  animate: { height: popperStatus ? height : 0, opacity: popperStatus ? 1 : 0 },
  transition: { duration: 0.3 },
})

export const searchBarVariants = {
  hidden: {
    x: '100%',
    opacity: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30,
    },
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30,
    },
  },
  exit: {
    x: '100%',
    opacity: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30,
    },
  },
}

export const drawerVariants = (isRTL) => ({
  open: {
    x: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30,
    },
  },
  closed: {
    x: isRTL ? '-100%' : '100%',
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30,
    },
  },
})
export const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (index) => ({
    opacity: 1,
    y: 0,
    transition: { delay: index * 0.02, duration: 0.2 },
  }),
}
export const statsMotionAnimations = {
  containerVariant: {
    hidden: { },
    visible: { },
  },
  childVariant: {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3, ease: 'easeOut' } },
  },
}
export const tableMotionAnimations = {
  ContainerAnimation: {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1, transition: { duration: 0.5, ease: 'easeOut' } },
  },
  ItemAnimation: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { duration: 0.3 },
  },
}
export const bellVariants = {
  hover: {
    x: [0, 0, 2, 0, 2, 0],
    y: [0, 0, 2, 0, 2, 0],
    transition: { duration: 0.5, ease: 'easeInOut' },
  },
}
